/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2172fc1899ca
 */

import { CloudinaryAssetMgmtCore } from "../core.js";
import { encodeFormQuery, encodeSimple } from "../lib/encodings.js";
import { compactMap } from "../lib/primitives.js";
import { safeParse } from "../lib/schemas.js";
import { RequestOptions } from "../lib/sdks.js";
import { extractSecurity, resolveGlobalSecurity } from "../lib/security.js";
import { pathToFunc } from "../lib/url.js";
import { APIError } from "../models/errors/apierror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import {
  GetResourceByAssetIdRequest,
  GetResourceByAssetIdRequest$zodSchema,
} from "../models/getresourcebyassetidop.js";
import { APICall, APIPromise } from "../types/async.js";
import { Result } from "../types/fp.js";

/**
 * Get resource by asset ID
 *
 * @remarks
 * Returns the details of a single resource specified by its asset ID.
 */
export function assetsGetResourceByAssetId(
  client$: CloudinaryAssetMgmtCore,
  asset_id: string,
  colors?: boolean | undefined,
  media_metadata?: boolean | undefined,
  faces?: boolean | undefined,
  quality_analysis?: boolean | undefined,
  accessibility_analysis?: boolean | undefined,
  pages?: boolean | undefined,
  phash?: boolean | undefined,
  coordinates?: boolean | undefined,
  versions?: boolean | undefined,
  max_results?: number | undefined,
  derived_next_cursor?: string | undefined,
  options?: RequestOptions,
): APIPromise<
  Result<
    Response,
    | APIError
    | SDKValidationError
    | UnexpectedClientError
    | InvalidRequestError
    | RequestAbortedError
    | RequestTimeoutError
    | ConnectionError
  >
> {
  return new APIPromise($do(
    client$,
    asset_id,
    colors,
    media_metadata,
    faces,
    quality_analysis,
    accessibility_analysis,
    pages,
    phash,
    coordinates,
    versions,
    max_results,
    derived_next_cursor,
    options,
  ));
}

async function $do(
  client$: CloudinaryAssetMgmtCore,
  asset_id: string,
  colors?: boolean | undefined,
  media_metadata?: boolean | undefined,
  faces?: boolean | undefined,
  quality_analysis?: boolean | undefined,
  accessibility_analysis?: boolean | undefined,
  pages?: boolean | undefined,
  phash?: boolean | undefined,
  coordinates?: boolean | undefined,
  versions?: boolean | undefined,
  max_results?: number | undefined,
  derived_next_cursor?: string | undefined,
  options?: RequestOptions,
): Promise<
  [
    Result<
      Response,
      | APIError
      | SDKValidationError
      | UnexpectedClientError
      | InvalidRequestError
      | RequestAbortedError
      | RequestTimeoutError
      | ConnectionError
    >,
    APICall,
  ]
> {
  const input$: GetResourceByAssetIdRequest = {
    asset_id: asset_id,
    colors: colors,
    media_metadata: media_metadata,
    faces: faces,
    quality_analysis: quality_analysis,
    accessibility_analysis: accessibility_analysis,
    pages: pages,
    phash: phash,
    coordinates: coordinates,
    versions: versions,
    max_results: max_results,
    derived_next_cursor: derived_next_cursor,
  };

  const parsed$ = safeParse(
    input$,
    (value$) => GetResourceByAssetIdRequest$zodSchema.parse(value$),
    "Input validation failed",
  );
  if (!parsed$.ok) {
    return [parsed$, { status: "invalid" }];
  }
  const payload$ = parsed$.value;
  const body$ = null;

  const pathParams$ = {
    asset_id: encodeSimple("asset_id", payload$.asset_id, {
      explode: false,
      charEncoding: "percent",
    }),
    cloud_name: encodeSimple("cloud_name", client$._options.cloud_name, {
      explode: false,
      charEncoding: "percent",
    }),
  };
  const path$ = pathToFunc("/v1_1/{cloud_name}/resources/{asset_id}")(
    pathParams$,
  );
  const query$ = encodeFormQuery({
    "accessibility_analysis": payload$.accessibility_analysis,
    "colors": payload$.colors,
    "coordinates": payload$.coordinates,
    "derived_next_cursor": payload$.derived_next_cursor,
    "faces": payload$.faces,
    "max_results": payload$.max_results,
    "media_metadata": payload$.media_metadata,
    "pages": payload$.pages,
    "phash": payload$.phash,
    "quality_analysis": payload$.quality_analysis,
    "versions": payload$.versions,
  });

  const headers$ = new Headers(compactMap({
    Accept: "application/json",
  }));
  const securityInput = await extractSecurity(client$._options.security);
  const requestSecurity = resolveGlobalSecurity(securityInput);

  const context = {
    options: client$._options,
    baseURL: options?.serverURL ?? client$._baseURL ?? "",
    operationID: "getResourceByAssetId",
    oAuth2Scopes: null,
    resolvedSecurity: requestSecurity,
    securitySource: client$._options.security,
    retryConfig: options?.retries
      || client$._options.retryConfig
      || { strategy: "none" },
    retryCodes: options?.retryCodes || [
      "429",
      "500",
      "502",
      "503",
      "504",
    ],
  };

  const requestRes = client$._createRequest(context, {
    security: requestSecurity,
    method: "GET",
    baseURL: options?.serverURL,
    path: path$,
    headers: headers$,
    query: query$,
    body: body$,
    userAgent: client$._options.userAgent,
    timeoutMs: options?.timeoutMs || client$._options.timeoutMs
      || -1,
  }, options);
  if (!requestRes.ok) {
    return [requestRes, { status: "invalid" }];
  }
  const req$ = requestRes.value;

  const doResult = await client$._do(req$, {
    context,
    errorCodes: [],
    retryConfig: context.retryConfig,
    retryCodes: context.retryCodes,
  });
  if (!doResult.ok) {
    return [doResult, { status: "request-error", request: req$ }];
  }
  return [doResult, {
    status: "complete",
    "request": req$,
    response: doResult.value,
  }];
}
